import React from "react";
import Card from "../components/Card";
import TimelineItem from "../components/TimelineItem";
import SummaryCard from "../components/SummaryCard";

const Dashboard = ({ signOut }) => {
  return (
    <div className="flex flex-col md:flex-row min-h-screen bg-gray-100 w-full">
      <main className="flex-1 p-4 md:p-6 overflow-x-hidden">
        <header className="flex flex-col md:flex-row justify-between items-start md:items-center mb-6">
          <h1 className="text-2xl md:text-3xl font-bold text-gray-800">
            Dashboard
          </h1>
          <button
            className="bg-red-600 text-white mt-4 md:mt-0 px-4 py-2 rounded hover:bg-red-700 text-sm md:text-base"
            onClick={async () => {
              try {
                await signOut(); // Sign out the user
                console.log("User signed out.");
              } catch (err) {
                console.log("Error signing out:", err);
              }
            }}
          >
            Sign Out
          </button>
        </header>

        <section className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
          <Card
            title="Portfolio Performance"
            content={
              <>
                <p className="text-gray-600">
                  Cash Deposits: <span className="font-bold">1.7M</span>
                </p>
                <p className="text-gray-600">54.1% less earnings</p>
                <p className="text-gray-600">
                  Invested Dividends: <span className="font-bold">9M</span>
                </p>
                <p className="text-gray-600">
                  Growth Rate: <span className="font-bold">14.1%</span>
                </p>
                <p className="text-gray-600">
                  Capital Gains: <span className="font-bold">$563</span>{" "}
                  (Increased by 7.3%)
                </p>
              </>
            }
            buttonLabel="View Complete Report"
          />

          <Card
            title="Technical Support"
            content={
              <>
                <p className="text-gray-600">
                  New Accounts Since 2018:{" "}
                  <span className="font-bold">78%</span>{" "}
                  <span className="text-green-500">(+14)</span>
                </p>
                <div className="mt-4">
                  <div className="h-2 bg-gray-200 rounded-full">
                    <div
                      className="h-2 bg-red-600 rounded-full"
                      style={{ width: "78%" }}
                    ></div>
                  </div>
                  <p className="text-gray-600 mt-2">Sales Progress: 100%</p>
                </div>
              </>
            }
            buttonLabel="View Details"
          />

          <Card
            title="Project Timeline"
            content={
              <ul className="mt-4 space-y-2">
                <TimelineItem color="text-red-500" text="All Hands Meeting" />
                <TimelineItem
                  color="text-yellow-500"
                  text="Build the production release"
                  newItem
                />
                <TimelineItem color="text-gray-500" text="Miscellaneous Task" />
              </ul>
            }
            buttonLabel="View All Events"
          />
        </section>

        <section className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-4 mt-8">
          <SummaryCard amount="$874" description="Sales Last Month" />
          <SummaryCard amount="$1283" description="Sales Income" />
          <SummaryCard amount="$1286" description="Last Month Sales" />
          <SummaryCard amount="$564" description="Total Revenue" />
        </section>
      </main>
    </div>
  );
};

export default Dashboard;
